import { css } from 'linaria'

export const iconRow = css`
  white-space: nowrap;
  display: flex;
  align-items: center;
`

const semiboldStyles = {
  fontFamily: '"Open Sans SemiBold", "Open Sans", Arial, sans-serif',
  fontWeight: 600
}

export const semibold = css`
  ${semiboldStyles};
`

export const pausedText = css`
  ${semiboldStyles};
  color: #CC0000;
`
